import { render, staticRenderFns } from "./RadioAnswer.vue?vue&type=template&id=060eb1e2"
import script from "./RadioAnswer.vue?vue&type=script&lang=js"
export * from "./RadioAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports